
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/travel/[...geonames]",
      function () {
        return require("private-next-pages/travel/[...geonames].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/travel/[...geonames]"])
      });
    }
  